"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_SignaExDiris_OnTurnStartedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let Effect_SignaExDiris_OnTurnStartedEventHandlerScript = class Effect_SignaExDiris_OnTurnStartedEventHandlerScript {
    run(sequence, container, handler, event) {
        const effect = container.getEffect(handler.args.scriptArgs.effectId);
        if ((effect === null || effect === void 0 ? void 0 : effect.args.__typeName) !== "SignaExDiris" || (effect === null || effect === void 0 ? void 0 : effect.removed)) {
            return;
        }
        // TODO:... fix this
        const debuffIds = container.applyDebuffs({
            sequence,
            attackerId: effect.creatorId,
            targetId: effect.targetId,
            // not hidden!
            // hidden: true,
            effects: [
                {
                    effect: new core_1.CurseEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new core_1.PoisonedEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new core_1.BleedingEffectArgs("Focus", 10),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }
            ]
        });
        const meta = effect.meta;
        meta.effectIds = (meta.effectIds || []).concat(debuffIds);
    }
};
Effect_SignaExDiris_OnTurnStartedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_SignaExDiris_OnTurnStarted")
], Effect_SignaExDiris_OnTurnStartedEventHandlerScript);
exports.Effect_SignaExDiris_OnTurnStartedEventHandlerScript = Effect_SignaExDiris_OnTurnStartedEventHandlerScript;
